<template>
  <div>
    <Form ref="formInline" :model="value" :rules="rule" :label-width="100" inline>
      <FormItem prop="company_name" label="名称:">
        <Input v-model="value.company_name" style="width: 200px" />
      </FormItem>
      <FormItem prop="tel" label="登录账号:">
        <!--  :disabled="value.id?true:false" -->
        <input
          class="ivu-input ivu-input-default"
          v-model="value.tel"
          style="width: 200px"
          :disabled="true"
          onkeyup="value=value.replace(/[^\w\u4E00-\u9FA5]/g, '')"
        />
      </FormItem>
      <FormItem prop="contacts" label="联系人:">
        <Input v-model="value.contacts" style="width: 200px" placeholder="联系人" />
      </FormItem>
      <FormItem prop="company_tel" label="电话:">
        <Input v-model="value.company_tel" style="width: 200px" placeholder="手机号码（必填）" />
      </FormItem>
      <FormItem prop="email" label="邮箱:">
        <Input v-model="value.email" style="width: 200px" />
      </FormItem>
      <FormItem prop="pay_type" label="支付类型:">
        <Select v-model="value.pay_type" style="width: 200px">
          <Option :value="0">后付</Option>
          <Option :value="1">预付</Option>
        </Select>
      </FormItem>
      <FormItem prop="quota_date" label="配额日期:">
        <Select v-model="value.quota_date" style="width: 200px">
          <Option v-for="i in 28" :key="i" :value="i">{{i}}</Option>
        </Select>
      </FormItem>
      <FormItem porp="agent_id" label="所属:" v-if="!user.tp">
        <Select v-model="value.agent_id" @on-change="selectChange" style="width: 200px">
          <Option
            v-for="(item,index) in agent"
            :key="index"
            :value="item.id"
          >{{item.id == user.id?"自营":item.agent_name}}</Option>
        </Select>
      </FormItem>
      <FormItem porp="al" label="地区:">
        <al-selector
          :gutter="0"
          style="width: 510px"
          data-type="name"
          searchable
          v-model="value.al"
          level="2"
        />
        <!-- @on-change="setAl" -->
      </FormItem>

      <FormItem prop="address" label="详细地址:">
        <Input v-model="value.address" style="width: 200px" placeholder="请勿重复输入省市区" />
      </FormItem>
      <FormItem prop="note" label="备注:">
        <Input v-model="value.note" style="width: 200px" />
      </FormItem>
    </Form>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { resolve } from "url";
export default {
  name: "type0",
  props: {
    value: {
      default() {
        return {
          id: 0,
          company_name:"",
          tel:"",
          contacts:"",
          company_tel:"",
          email:"",
          pay_type:"",
          quota_date:"",
          agent_id:"",
          al:[],
          address:"",
          note:"",
        };
      },
      type: Object
    },
    agent: Array
  },
  data() {
    return {
      rule: {
        tel: [
          { required: true, message: "请输入公司登录账号", trigger: "blur" }
        ],
        company_name: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        contacts: [
          { required: true, message: "请输入联系人", trigger: "blur" }
        ],

        company_tel: [
          {
            validator: (rule, value, callback) => {
              if (!value) {
                callback(new Error("请输入电话"));
                return false;
              }
              if (value.length !== 11) {
                callback(new Error("请输入正确的手机号码"));
                return false;
              }
              callback();
            },
            required: true,
            trigger: "blur"
          }
        ],
        email: [
          {
            validator: (rule, value, callback) => {
              var filter = /^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/;
              if (filter.test(value)) {
                callback();
              } else {
                callback(new Error("请输入正确的邮箱地址"));
              }
            },
            required: true,
            trigger: "blur"
          }
        ],
        al: [{ required: true, message: "请选择所在地区", trigger: "blur" }],
        address: [
          { required: true, message: "请输入详细地址", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    formValidate() {
      this.$refs.formInline.validate(valid => {
        this.$emit("valid", valid);
      });
    },
    setAl(value) {
      this.value.al = value;
    },
    selectChange() {
      this.$emit("agent-change", this.value.agent_id);
    },
    ...mapActions([""])
  },
  computed: mapGetters({
    user: "agent"
  })
};
</script>
<style lang='less'>
</style>
